import { UnexpectedError } from './UnexpectedError';

export class ValidationError extends UnexpectedError {
	constructor(message: string, error?: unknown) {
		super(message, error, 'ERROR_VALIDATION');
	}
}
